export function useHasDiscount(discountPrice, discountDateStart, discountDateEnd) {
    if (!discountDateStart || !discountDateEnd) {
        return false;
    }
    return (Date.parse(discountDateStart) <= Date.now()) && (Date.parse(discountDateEnd) > Date.now()) && discountPrice;
}

export function useFormatPrice(price) {
    return Number(price).toFixed(2).replace('.', ',');
}
